module.exports = __webpack_public_path__ + "img/the-stringless.1b083cc4.webp";